import $ from 'jquery';
import app from '../app';
const { $document } = app.el;

function replaceNotPlayable(video) {
  video.outerHTML = `
    <div class="como-video-error">
      <div class="como-video-error__tips typography--body2">
        <i class="ri-file-damage-fill como-video-error__tips__icon"></i>
        <span>${
          window.Drupal ? Drupal.t('The video is temporarily unavailable') : '视频损坏无法播放'
        }</span>
      </div>
    </div>
  `;
}

$document
  .on('loadstart', function () {})
  .on('error', function ({ target }) {
    replaceNotPlayable(target);
    console.warn('video error');
  })
  .on('emptied', function () {})
  .on('play', function ({ target }) {
    let currVideo = target.querySelector('video');
    let allVideos = document.querySelectorAll('#main video');
    allVideos.forEach(function (video) {
      if (video != currVideo) video.pause();
    });
  })
  .on('ended', function ({ target }) {
    let currVideo = target.querySelector('video');
    currVideo.load();
  });
